var moduleMap = {
	"./mountPlay": () => {
		return Promise.all(/* __federation_expose_mountPlay */[__webpack_require__.e(9342), __webpack_require__.e(6593), __webpack_require__.e(7291), __webpack_require__.e(2184), __webpack_require__.e(1955), __webpack_require__.e(1776), __webpack_require__.e(9673), __webpack_require__.e(4113)]).then(() => (() => ((__webpack_require__(45013)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});